
function spam(params) {
const checkoutBtn = document.querySelectorAll(`button[name='checkout']`);

let isProcessing = true;
if (checkoutBtn.length) {
    checkoutBtn.forEach(element => {
        element.addEventListener("click", function(e) {
            if (isProcessing) {
                return false;
            }

            // Bắt đầu trạng thái đang xử lý
            isProcessing = true;
            element.disabled = true; // Disable nút
            element.classList.add('bss-disable')
            // Giả lập gửi request
            setTimeout(() => {

                isProcessing = false;
                element.disabled = false;
                element.classList.remove('bss-disable')
            }, 3000); // 5s reset
        });
    });

}
let input = document.querySelector(' .drawer__content .cart-quantity input')
if (input) {
    input.addEventListener('change', () => {
        setTimeout(()=>{
         if (typeof BSS_B2B == 'object') {
            BSS_B2B.observer.cartSubject.listenCartCheckout()
             spam()
        }
        },1500)
       
    })
}

}

spam()
let quickAddDrawer = document.querySelector('main-cart ')
if (quickAddDrawer) {
    let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
            if (m.addedNodes.length) {
                 if (typeof BSS_B2B == 'object') {
            BSS_B2B.observer.cartSubject.listenCartCheckout()
             spam()
        }
                
            }
        });
    });
    observer.observe(quickAddDrawer, {
        childList: true
    });
}
let Drawer = document.querySelector('.shopify-section:has(.drawer__footer-body)')

if (Drawer) {
    let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
            if (m.addedNodes.length) {
                 console.log('sda')
                if (typeof BSS_B2B == 'object') {
                    spam()
                    BSS_B2B.observer.cartSubject.listenCartCheckout()
                }

            }
        });
    });
    observer.observe(Drawer, {
        childList: true
    });
}

let addTocart =document.querySelectorAll('.product-card__atc.product-card__action-button , .product-form__buttons')
if (addTocart.length) {
    addTocart.forEach((e)=>{
        e.addEventListener('click', ()=>{
            setTimeout(() => {
                BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
            }, 1500);
        })
    })
}

const targetNode = document.getElementById("CartDrawer");

const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;

if (pageType !== "cart") {
  let counter = 0;
  const interval = setInterval(() => {
    const footerPrice = document.querySelector(".drawer__footer-body");
    const taxExWrapper = document.querySelector(".bss-b2b-tax-ex-wrapper.bss-config-header");

    if (footerPrice && taxExWrapper) {
      footerPrice.parentNode.insertBefore(taxExWrapper, footerPrice);
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
} else {
  let counter = 0;
  const interval = setInterval(() => {
    const vatInputWrapper = document.querySelector(".bss-b2b-vat-input-wrapper");

    if (vatInputWrapper) {
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
}

function handleTEBox() {
  const translations = BSS_B2B.te.teTranslations;
  const headerText = document.querySelector(
    ".bss-b2b-translation-vat-form_header_text"
  );
  if (headerText) {
    headerText.innerText = translations.form_header_text;
  }

  const subtitleText = document.querySelector(
    ".bss-b2b-translation-vat-form_subtitle_text"
  );
  if (subtitleText) {
    subtitleText.innerText = translations.form_subtitle_text;
  }

  const successMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_success_message"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_success_message_us_ein"
    ),
  ];

  successMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_success_message || "";
          break;
        case 1:
          msg.innerText = translations.form_success_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_success_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_success_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_success_message_us_ein || "";
          break;
      }
    }
  });

  const errorMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_error_message"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_error_message_us_ein"
    ),
    document.querySelector(
      ".bss-b2b-translation-vat-form_validate_country_code_message"
    ),
  ];

  errorMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_error_message || "";
          break;
        case 1:
          msg.innerText = translations.form_error_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_error_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_error_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_error_message_us_ein || "";
          break;
        case 5:
          msg.innerText = translations.form_validate_country_code_message || "";
          break;
      }
    }
  });
}

document.addEventListener('cart:rerendered', ()=> {
  if(BSS_B2B){
    BSS_B2B.observer.cartSubject.listenCartCheckout();
  }
})
